export { default as useAttributes } from './useAttributes';
